import axios from 'axios';
import { base64toBlob } from '../../../@iosper/utils/Format';
import { mockPdfResponse } from '../mocks/ordenPDFMock';

/**
 * Reimprimir orden api call
 * @returns
 */
export const recuperarOrdenPDF = async (token) => {
  // return mockeado por ahora, luego se reemplaza por la llamada real a la API
  // return Promise.resolve({
  //   status: 200,
  //   json: () => Promise.resolve(mockPdfResponse),
  // })
  //   .then(async (result) => {
  //     // Obtener el mockPdfResponse del json()
  //     const pdfData = await result.json();
  //     //Create a Blob from the PDF Stream
  //     const file = base64toBlob(pdfData.data, 'application/pdf');
  //     //Build a URL from the file
  //     const fileURL = URL.createObjectURL(file);
  //     return fileURL;
  //   })
  //   .catch((e) => {
  //     return Promise.reject(e);
  //   });

  return (
    axios
      .get(`/v1/orden/pdf/${token}`, {
        headers: {
          'Content-Type': 'application/json',
          responseType: 'arraybuffer',
          Accept: 'application/pdf',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        }
      })
      .then((result) => {
        //Create a Blob from the PDF Stream
        const file = base64toBlob(result.data, 'application/pdf');
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        return fileURL;
      })
      .catch((e) => {
        return Promise.reject(e);
      })
  );
};
